<template>
  <v-app>
    <MainHeader />
    <v-main>
      <router-view />
    </v-main>
    <MainFooter />
  </v-app>
</template>

<script>
import MainFooter from "./components/common/MainFooter.vue";
import MainHeader from "./components/common/MainHeader.vue";
export default {
  data: () => ({
    //
  }),
  components: { MainHeader, MainFooter },
};
</script>
<style>
@import "@/assets/css/style.css";
@import "@/assets/css/bootstrap.css";
</style>
